import {
  ReactElement,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from 'react'
import UserAction from '../../../context/action/UserAction'
import { UserContext } from '../../../context/UserContext'
import DevelopusSnackbarContext from '../../../../../common/ui/snackbar/DevelopusSnackbarContext'
import DevelopusSnackbarActions from '../../../../../common/ui/snackbar/DevelopusSnackbarActions'
import DevelopusCancelButton from '../../../../../common/ui/button/DevelopusCancelButton'
import DevelopusButton from '../../../../../common/ui/button/DevelopusButton'
import { SaveOutlined } from '@mui/icons-material'
import { TabContext, TabPanel } from '@mui/lab'
import { Tab, Tabs } from '@mui/material'
import { t } from 'i18next'
import StudentCreateForm from './StudentCreateForm'

const StudentCreate = (): ReactElement => {
  const snackbarContext = useContext(DevelopusSnackbarContext)
  const snackbarActions = new DevelopusSnackbarActions(snackbarContext)

  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [saveDisabled, setSaveDisabled] = useState<boolean>(true)

  useEffect(() => {
    setSaveDisabled(!action.isValid())
  }, [action.isValid()])

  const [tabValue, setTabValue] = useState('info')
  const handleTabChange = (_: SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
  }

  const handleEdit = async (): Promise<void> => {
    await action.createStudent()
    snackbarActions.showSnackbar('Student created')
    action.refreshStudentsPage()
  }

  const exit = (): void => {
    action.refreshStudentsPage()
  }

  return (
    <div>
      <div style={{ position: 'absolute', right: '30px', zIndex: 1000 }}>
        <DevelopusCancelButton text={t('common.cancel')} handleClick={exit} />
        <DevelopusButton
          text={t('common.save')}
          handleClick={handleEdit}
          disabled={saveDisabled}
          icon={<SaveOutlined />}
        />
      </div>

      <TabContext value={tabValue}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab
            value="info"
            label={t('users.common.information')}
            className="tab-label"
          />
        </Tabs>

        <TabPanel value="info">
          <StudentCreateForm />
        </TabPanel>
      </TabContext>
    </div>
  )
}

export default StudentCreate
